import VueComponent from "vue"

const errorMapper = {
  string_gte: 'min',
  string_lte: 'max',
  number_gte: 'min',
  number_gt: 'min',
  number_lte: 'max',
  number_lt: 'max',
  format: 'format',
  pattern: 'pattern',
  unique: 'type',
  array_max_items: 'max',
  array_min_items: 'min',
  enum: 'allowed',
  invalid_type: 'expected',
  missing_dependency: 'dependency',
  required: 'property'
}

let verbosity = false

export default {
  install: function (Vue, options) {
    options = options || {}
    // let propertyKey = options.propertyKey || '$formError'

    verbosity = options.verbosity || verbosity

    Vue.mixin({
      ...options.components,
      methods: {
        populateFormError: function (formRef, error) {
          const self = this
          return new Promise(
              function (resolve, reject) {
                if (error && error.response && error.response.status === 422) {
                  let errors = {}

                  if (formRef instanceof VueComponent) {
                    (error.response.data || []).forEach((errdata) => {
                      // get field in validator to set id in error
                      let field = errdata.details && errdata.details.property ? errdata.details && errdata.details.property : errdata.field

                      // get parent of nested properties, delete (root). from description
                      // replacement only works, if (root) not the only content of string
                      let contextField = errdata.details && errdata.details.context ? errdata.details.context.replace(/\(root\)\./, '') : ''

                      if (contextField !== '' && contextField !== field) {
                        // build complete name of nested property with parent and property
                        field = contextField + '.' + field
                      }

                      if (!Array.isArray(errors[field])) {
                        errors[field] = []
                      }

                      // details optional, only required when server validation with schema
                      if (errdata.message && errdata.details && errdata.details[errorMapper[errdata.message]]) {
                        errdata.message = self.$t('VALIDATION.SERVER.' + errdata.message.toUpperCase(), {expected: self.$t(errdata.details[errorMapper[errdata.message]]) || ''})
                      } else if (errdata.message) {
                        // Localize error.message by default, if exists
                        errdata.message = self.$t('VALIDATION.SERVER.' + errdata.message.toUpperCase())
                      }

                      errors[field].push(errdata.message)
                    })

                    formRef.setErrors(errors)
                    return resolve(error)
                  }
                }

                return reject(error)
              }
          )
        }
      }
    })
  }
}
